import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import { MatMenuModule } from '@angular/material/menu';

import { TranslateModule } from '@ngx-translate/core';

import { ConfirmSubscriptionTransferModule } from '@shared/components/dialogs/confirm-subscription-transfer/confirm-subscription-transfer.module';
import { DefaultImageModule } from '@shared/directives/default-image.module';

import { HeaderComponent, CantSelfPayDialog } from './header.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [HeaderComponent, CantSelfPayDialog],
  exports: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    DefaultImageModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule, MobileTooltipTriggerDirective,
    MatMenuModule,
    ConfirmSubscriptionTransferModule,
    MatIconModule,
  ],
})
export class HeaderModule {}
